import { render, staticRenderFns } from "./BookingLayout.vue?vue&type=template&id=22ccc537&lang=pug"
import script from "./BookingLayout.vue?vue&type=script&lang=js"
export * from "./BookingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports